import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    marginTop: 16
  },
  contentCard: {
    marginTop: 16
  },
  tableFilter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none!important'
    }
  }
}))
